import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { DocumentoVersao } from "../../../types/documento/versao/DocumentoVersao";
import { DocumentoVersaoList } from "../../../types/documento/versao/DocumentoVersaoList";

const endpointUrl = configUrls.DOCUMENTO_VERSAO_EP;

/**versoes */

function getDocumentoVersoes({ id, search }: { id: string; search: string }) {
  if (!id) {
    // Se 'documento' for null/undefined ou não tiver 'id', não faz a chamada à API.
    return {
      url: "",
      method: "",
    };
  }

  return {
    url: `${endpointUrl}/versoes/${id}?search=${search}`,
    method: "GET",
  };
}

function getDocumentoVersao(id: string) {
  if (!id) {
    // Se 'documento' for null/undefined ou não tiver 'id', não faz a chamada à API.
    return {
      url: "",
      method: "",
    };
  }

  return {
    url: `${endpointUrl}/versao/${id}`,
    method: "GET",
  };
}
/** */

export const documentoVersaoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getDocumentoVersoes: query<
      DocumentoVersaoList[],
      { id: string; search: string }
    >({
      query: getDocumentoVersoes,
      providesTags: ["DocumentoVersao"],
    }),

    getDocumentoVersao: query<DocumentoVersao, string>({
      query: getDocumentoVersao,
      providesTags: ["DocumentoVersao"],
    }),
  }),
});

export const { useGetDocumentoVersaoQuery, useGetDocumentoVersoesQuery } =
  documentoVersaoApiSlice;
